import React, { FC, useState } from "react";
import AnyReactComponent from "components/AnyReactComponent/AnyReactComponent";
import StayCardH from "components/StayCardH/StayCardH";
import GoogleMapReact from "google-map-react";
import { DEMO_HOTEL_LISTINGS, DEMO_STAY_LISTINGS } from "data/listings";
import { DEMO_HOTELS } from "data/hotels";
import ButtonClose from "shared/ButtonClose/ButtonClose";
import Checkbox from "shared/Checkbox/Checkbox";
import Pagination from "shared/Pagination/Pagination";
import TabFilters from "./TabFilters";
import Heading2 from "components/Heading/Heading2";
import { HotelType } from "data/types";

const DEMO_STAYS = DEMO_HOTEL_LISTINGS.filter((_, i) => i < 12);
const DEMO_HOTELS_DATA = DEMO_HOTELS.filter((_, i) => i );

export interface SectionGridHasMapProps {
  data?: HotelType[]
}

const SectionGridHasMap: FC<SectionGridHasMapProps> = ({data = DEMO_HOTELS_DATA}) => {
  const [currentHoverID, setCurrentHoverID] = useState<string | number>(-1);
  const [showFullMapFixed, setShowFullMapFixed] = useState(false);

  //Pagination
 const dataLimit = 8;
 const [pages] = React.useState(Math.round(data.length / dataLimit));
 const [currentPage, setCurrentPage] = React.useState(1);

 function changePage(event: React.MouseEvent<HTMLButtonElement>) {
  const pageNumber = Number(event.currentTarget.textContent);
  setCurrentPage(pageNumber);
}

  const getPaginatedData = () => {
    const startIndex = currentPage * 8 - dataLimit;
    const endIndex = startIndex + dataLimit;
    return data.slice(startIndex, endIndex);
  };

  return (
    <div>
      <div className="relative flex min-h-screen">
        {/* CARDSSSS */}
        <div className="min-h-screen w-full xl:w-[780px] 2xl:w-[880px] flex-shrink-0 xl:px-8 ">
          <Heading2 heading="Search on a map" />
          <div className="mb-8 lg:mb-11">
           {/*<TabFilters />*/}
          </div>
          <div className="grid grid-cols-1 gap-8">
            {DEMO_HOTELS_DATA.map((item) => (
              <div
                key={item.id}
                onMouseEnter={() => setCurrentHoverID((_) => item.id)}
                onMouseLeave={() => setCurrentHoverID((_) => -1)}
              >
                <StayCardH data={item} />
              </div>
            ))}
          </div>
          <div className="flex mt-16 justify-center items-center">
            <Pagination
              pages={pages}
              currentPage={currentPage}
              changePage={changePage}
            />
          </div>
        </div>

        {!showFullMapFixed && (
          <div
            className="flex xl:hidden items-center justify-center fixed bottom-8 left-1/2 transform -translate-x-1/2 px-6 py-2 bg-neutral-900 text-white shadow-2xl rounded-full z-30  space-x-3 text-sm cursor-pointer"
            onClick={() => setShowFullMapFixed(true)}
          >
            <i className="text-lg las la-map"></i>
            <span>Show map</span>
          </div>
        )}

        {/* MAPPPPP */}
        <div
          className={`xl:flex-grow xl:static xl:block ${
            showFullMapFixed ? "fixed inset-0 z-50" : "hidden"
          }`}
        >
          {showFullMapFixed && (
            <ButtonClose
              onClick={() => setShowFullMapFixed(false)}
              className="bg-white absolute z-50 left-3 top-3 shadow-lg rounded-xl w-10 h-10"
            />
          )}

          <div className="fixed xl:sticky top-0 xl:top-[88px] left-0 w-full h-full xl:h-[calc(100vh-88px)] rounded-md overflow-hidden">
            <div className="absolute bottom-5 left-3 lg:bottom-auto lg:top-2.5 lg:left-1/2 transform lg:-translate-x-1/2 py-2 px-4 bg-white dark:bg-neutral-800 shadow-xl z-10 rounded-2xl min-w-max">
              <Checkbox
                className="text-xs xl:text-sm"
                name="xx"
                label="Search as I move the map"
              />
            </div>

            {/* BELLOW IS MY GOOGLE API KEY -- PLEASE DELETE AND TYPE YOUR API KEY */}
            <GoogleMapReact
              defaultZoom={12}
              defaultCenter={{
                lat: 4.8594,
                lng: 31.5713,
              }}
              bootstrapURLKeys={{
                key: "AIzaSyBvH9d5az9TjQZQ97Eb0DmFzNVr1qqCcUk",
              }}
              yesIWantToUseGoogleMapApiInternals
            >
              {DEMO_HOTELS_DATA.map((item) => (
                <AnyReactComponent
                  isSelected={currentHoverID === item.id}
                  key={item.id}
                  lat={item.lat}
                  lng={item.long}
                  listing={item}
                  
                />
              ))}
            </GoogleMapReact>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SectionGridHasMap;
